import React from 'react';
import { Medal, Unlock } from 'lucide-react';
export function EliteUpgrade() {
  return <section className="py-20 bg-slate-50 border-b border-slate-200" data-id="element-60">
      <div className="max-w-4xl mx-auto px-4" data-id="element-61">
        <div className="text-center mb-12" data-id="element-62">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-4" data-id="element-63">
            ¿Qué agrega el Megapack Élite?
          </h2>
          <p className="text-lg text-gray-600" data-id="element-64">
            Por solo $9.000 más, llevás tu enseñanza al siguiente nivel.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-65">
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-yellow-200 relative overflow-hidden" data-id="element-66">
            <div className="absolute top-0 right-0 w-32 h-32 bg-yellow-50 rounded-bl-full -z-10" data-id="element-67"></div>
            <Medal className="w-12 h-12 text-yellow-500 mb-6" data-id="element-68" />
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-69">
              Élite 1 — EL CAZADOR DE DÉCIMAS
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-70">
              El manual de limpieza técnica para enamorar a los jueces.
              Protocolos por aparato, checklist pre-torneo y el sistema para
              recuperar hasta 1.20 puntos sin cambiar ni un solo elemento de la
              rutina. No improvises más frente al jurado.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm border border-blue-200 relative overflow-hidden" data-id="element-71">
            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-50 rounded-bl-full -z-10" data-id="element-72"></div>
            <Unlock className="w-12 h-12 text-blue-500 mb-6" data-id="element-73" />
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-74">
              Élite 2 — EL CÓDIGO DE LAS DIFICULTADES
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-75">
              Micro-progresiones para destrabar a cualquier gimnasta estancada.
              Protocolos de desbloqueo por elemento (vertical, flic-flac, kip,
              rondada, mortal) y psicología aplicada para eliminar el miedo al
              vuelo. Convertite en el profe que logra lo que nadie más pudo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}